<script>
import BaseStream from "@homepage/components/pageStyles/BaseStream";
import ResultDisplay from "@homepage/components/ResultHorizontalDisplay.vue";
import {generateImageMapFor} from "@homepage/helpers/image";

export default {
	name: "Stream.vue",
	extends: BaseStream,
	components: {
		ResultDisplay
	},
	provide() {
		return {
			imagesMap: generateImageMapFor('quickmoney'),
		};
	},
}
</script>

<template>
	<div>
		<winning-numbers-sidebar :open.sync="sidebarOpen" :results="externalLotteriesResults"></winning-numbers-sidebar>
		<v-btn id="external-results-btn" @click="sidebarOpen = !sidebarOpen" style="z-index: 4">
			Winning Numbers
		</v-btn>
		<v-row justify="center">
			<v-col cols="auto">
				<v-img contain height="200" :src="require('@/assets/img/paradiseLottery/logo.png')"></v-img>
			</v-col>
		</v-row>
		<v-row justify="center">
			<v-col cols="auto">
				<v-btn id="see-it-live-btn" class="d-flex" @click="scrollToStream">
					See it live
				</v-btn>
			</v-col>
		</v-row>
		<v-row justify="center" class="mb-5">
			<v-col
				lg="4"
				sm="6"
				cols="12"
				v-for="result in results.slice(0, 10)"
				:key="`${result.date}-${result.sortition.id}`">
				<v-card>
					<result-display class="result-card"
													:pick-three-image="{ src: require('@/assets/img/paradiseLottery/pick3.webp'), width: '75px', height: '45px', contain: true, class: 'd-block' }"
													:pick-four-image="{ src: require('@/assets/img/paradiseLottery/pick4.webp'), width: '75px', height: '50px', contain: true, class: 'd-block' }"
													:result="result">
						<template #name="{sortition}">
							<h2>
								{{ sortition.name }}
							</h2>
						</template>
					</result-display>
				</v-card>
			</v-col>
		</v-row>

		<v-responsive :aspect-ratio="16 / 9">
			<iframe
				v-if="channelName && channelName.length > 0"
				id="frame"
				:src="
          `https://player.twitch.tv/?channel=${channelName}&parent=paradisepick.tv&parent=localhost`
        "
				frameborder="0"
				scrolling="no"
				allowfullscreen="true"
			>
			</iframe>
		</v-responsive>
	</div>
</template>

<style scoped lang="scss">
#frame {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	border: 0;
}
</style>
